import { render, staticRenderFns } from "./Push.vue?vue&type=template&id=50fba44c&scoped=true&"
import script from "./Push.vue?vue&type=script&lang=js&"
export * from "./Push.vue?vue&type=script&lang=js&"
import style0 from "./Push.vue?vue&type=style&index=0&id=50fba44c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50fba44c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wp/Desktop/chuanti-pc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50fba44c')) {
      api.createRecord('50fba44c', component.options)
    } else {
      api.reload('50fba44c', component.options)
    }
    module.hot.accept("./Push.vue?vue&type=template&id=50fba44c&scoped=true&", function () {
      api.rerender('50fba44c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/Push.vue"
export default component.exports